import customAxios from "../serverCall";

// const AuthService = () => {
const getDashboard = async (body) => {
  const response = await customAxios.post(
    `/admin/dashboard/accountwisecount`,
    body
  );

  return response;
};
const dateFilterForAll = async (body) => {
  const response = await customAxios.post(
    `/admin/dashboard/accountwisecount/bydate`,
    body
  );

  return response;
};

const DashboardService = {
  getDashboard,
  dateFilterForAll
};

export default DashboardService;
